import Eyebrow from '@/components/Eyebrow/Eyebrow';
import useGlobalStyles, { ResponsiveTypeVariant } from '@/styles/global.styles';

import useStyles from './SectionHeader.styles';

interface SectionHeaderProps {
  className?: string;
  subheadingClassName?: string;
  eyebrow?: string;
  heading?: string;
  subheading?: string;
  isOnDark?: boolean;
  fixed?: boolean;
  subheadingFontStyle?:
    | ResponsiveTypeVariant.body
    | ResponsiveTypeVariant.body2;
  headingSpacingValue?: 0 | 1;
  isH1?: boolean;
}

export default function SectionHeader({
  className,
  subheadingClassName,
  eyebrow,
  heading,
  subheading,
  isOnDark = true,
  fixed = false,
  subheadingFontStyle = ResponsiveTypeVariant.body2,
  headingSpacingValue = 0,
  isH1 = false,
}: SectionHeaderProps): React.JSX.Element {
  const { classes: globalClasses } = useGlobalStyles({ fixed });
  const { classes, cx } = useStyles({ headingSpacingValue });

  return (
    <div
      className={cx(
        classes.contentContainer,
        isOnDark ? classes.onDark : classes.onLight,
        className
      )}
    >
      {eyebrow && <Eyebrow text={eyebrow} isOnDark={isOnDark} />}
      {heading &&
        (isH1 ? (
          <h1 className={cx(globalClasses.h1, 'primaryTextColor')}>
            {heading}
          </h1>
        ) : (
          <h2 className={cx(globalClasses.h2, 'primaryTextColor')}>
            {heading}
          </h2>
        ))}

      {subheading && (
        <p
          className={cx(
            classes.subheading,
            globalClasses[subheadingFontStyle],
            'accentTextColor',
            subheadingClassName
          )}
        >
          {subheading}
        </p>
      )}
    </div>
  );
}
